module.exports = __webpack_public_path__ + "static/media/boss-armor-yellow.80802dbb.png";